import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ICity, IDistrict, IWard } from "src/_cores/_interfaces";
import { showError, showSuccess } from "src/_cores/_reducers/alert.reducer";
import { clearCart, updateProductPrice } from "src/_cores/_reducers/cart.reducer";
import CommonService from "src/_cores/_services/common.service";
import OmsService from "src/_cores/_services/oms.service";
import SalesService from "src/_cores/_services/sales.service";
import { AppDispatch, useCartStore } from "src/_cores/_store/root-store";
import { MuiIcon, WebDirectional } from "src/_shares/_components";
import { ICON_NAME } from "src/_shares/_components/mui-icon/_enums/mui-icon.enum";
import { ProductHelper } from "src/_shares/_helpers/product-helper";

const PaymentPage = () => {
    const navigate = useNavigate();
    const cartStore = useCartStore();
    const dispatch = useDispatch<AppDispatch>();
    const [open, setOpen] = useState(false);
    const [cities, setCitites] = useState<ICity[]>([]);
    const [districts, setDistricts] = useState<IDistrict[]>([]);
    const [wards, setWards] = useState<IWard[]>([]);
    const [orderResponse, setOrderResponses] = useState<any>(undefined);
    const [dataDetail, setDataDetail] = useState<{ [key: string]: any }>({});
    const [banks, setBanks] = useState<any>([]);

    useEffect(() => {
        dispatch(updateProductPrice(cartStore.productsInCart.map(_ => _.id)));
        getCities();
    }, []);

    const handleProcessOrder = async () => {
        if (!dataDetail['phoneNumber'] || !dataDetail['cityCode'] || !dataDetail['districtCode'] || !dataDetail['wardCode'] || !dataDetail['address']) {
            dispatch(showError('Vui lòng nhập đầy đủ thông tin'));
            return;
        }
        if (!dataDetail['paymentMethod']) {
            dispatch(showError('Vui lòng phương thức thanh toán'));
            return;
        }

        const param = {
            vouchers: cartStore.vouchers.map(_ => _.voucher),
            deliveryInfo: dataDetail,
            products: cartStore.productsInCart
        }

        const response = await OmsService.createOrder(param) as any;
        if (response?.isSucceed) {
            setOrderResponses(response.data);
            dispatch(showSuccess(`Đặt hàng thành công`));
            dispatch(clearCart());
            if (dataDetail['paymentMethod'] === 'bank') {
                const resBanks = await SalesService.getPaymentMethods() as any;
                if (resBanks?.isSucceed) {
                    setBanks(resBanks.data);
                    setOpen(true);
                }
                return;
            }
            setOrderResponses(undefined);
            window.location.reload();
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const getCities = async () => {
        const res = await CommonService.getCities() as any;
        if (res.isSucceed) {
            setCitites(res.data);
        }
    }

    const onChangeCity = async (code: string) => {
        const _dataDetail = {
            ...dataDetail,
            cityCode: code,
            districtCode: '',
            wardCode: ''
        }
        setDataDetail(_dataDetail);
        setDistricts([]);
        setWards([]);
        await getDistricts(code);
    }

    const getDistricts = async (code: string) => {
        const res = await CommonService.getDistrictsByCityCode(code) as any;
        if (res.isSucceed) {
            setDistricts(res.data);
        }
    }

    const onChangeDistrict = async (code: string) => {
        const _dataDetail = {
            ...dataDetail,
            districtCode: code,
            wardCode: ''
        }
        setDataDetail(_dataDetail);
        setWards([]);
        await getWards(code);
    }

    const getWards = async (code: string) => {
        const res = await CommonService.getWardsByDistrictCode(code) as any;
        if (res.isSucceed) {
            setWards(res.data);
        }
    }

    const onChangeWard = (code: string) => {
        onChangeFieldValue('wardCode', code);
    }

    const onChangeFieldValue = (field: string, value: any) => {
        setDataDetail({ ...dataDetail, [field]: value });
    }

    const getFormatedPrice = (price: number) => {
        return ProductHelper.getFormatedPrice(price);
    }

    return (
        <div className="custom-container">
            <div className="content__inner">
                <WebDirectional items={[
                    { path: '/cart', name: 'Giỏ Hàng' },
                    { path: '/payment', name: 'Thanh toán' }
                ]} />
                <div className="billing-summary">
                    <div className="cart-title text-center">HÓA ĐƠN CỦA BẠN</div>
                    {cartStore.productsInCart.length === 0 ? (
                        <div className="cart-body flex flex-wrap">
                            <div className="primary-cartcontent">
                                <div className="cart-bottom flex justify-center lg:justify-start">
                                    <button
                                        className="py-2 px-4 sm:w-full lg:w-48 bg-[#4D4D4D] text-white
                                        border border-solid border-black inline-block text-center
                                        hover:bg-[#fff] hover:text-gray-700  transition duration-500"
                                        onClick={() => navigate(-1)}
                                    >
                                        <strong>Quay lại</strong>
                                    </button>
                                </div>
                                <div className="text-center text-gray-500 mt-4">
                                    Chưa có sản phẩm
                                </div>
                            </div>
                        </div>
                    ) : (<>
                        <div className="flex flex-wrap mb-5">
                            <div className="primary-cartcontent">
                                <div className="cart-head">
                                    <span>
                                        <strong>Sản phẩm</strong>
                                    </span>
                                    <span className="">
                                        <strong>Số lượng</strong>
                                    </span>
                                    <span className="">
                                        <strong>Giảm giá</strong>
                                    </span>
                                    <span className="text-right">
                                        <strong>Thành tiền</strong>
                                    </span>
                                </div>
                                <div className="cart-products">
                                    {cartStore.productsInCart.map(_ => (
                                        <div key={_.uniqId} className="cart-product flex flex-wrap w-full">
                                            <div className="cart-product__image">
                                                <img src={`${process.env.REACT_APP_IMAGE_URL}/products/${_.image}`} alt="" />
                                            </div>
                                            <div className="cart-product__info">
                                                <div className="cart-product--auto">
                                                    <div><strong>{_.name}</strong></div>
                                                    <div>{_.shopName}</div>
                                                    {_.options.length > 0 && (
                                                        <div>({_.options.map((o: any) => o.valueName).join(', ')})</div>
                                                    )}
                                                    <div className="price">
                                                        <span className="value">{getFormatedPrice((_.discount ?? _.price))}</span>
                                                    </div>
                                                </div>
                                                <div className="cart-product--col">
                                                    x{_.qty}
                                                </div>
                                                <div className="cart-product--col">
                                                    {_.discountFromVoucher > 0 && `-${getFormatedPrice(_.discountFromVoucher)}`}
                                                </div>
                                                <div className="cart-product--col totalprice text-right">
                                                    <span className="total-value">{getFormatedPrice((_.finalPrice))}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="cart-bottom billing-total">
                                        <div className="attr mb-2 flex justify-between ml-auto mr-0">
                                            <span>Số lượng:</span>
                                            <span className="">{cartStore.totalQty}</span>
                                        </div>
                                        <div className="attr mb-2 flex justify-between ml-auto mr-0">
                                            <span>Tạm tính:</span>
                                            <span className="">{getFormatedPrice(cartStore.totalPrice)}</span>
                                        </div>
                                        <div className="attr mb-2 flex justify-between ml-auto mr-0">
                                            <span>Giảm:</span>
                                            <span className="">{cartStore.totalDiscount > 0 && `-${getFormatedPrice(cartStore.totalDiscount)}`}</span>
                                        </div>
                                        <div className="attr mb-2 flex justify-between ml-auto mr-0">
                                            <span className="text">
                                                TỔNG CỘNG:
                                            </span>
                                            <span className="value">
                                                <strong>{getFormatedPrice(cartStore.totalFinalPrice)}</strong>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Grid container spacing={3}>
                            <Grid className="user-info" item xs={7}>
                                <div className="title">
                                    <strong>THÔNG TIN GIAO HÀNG</strong>
                                </div>
                                <div className="payment-info__line w-full flex items-center relative">
                                    <span style={{ color: 'red', position: 'absolute', left: '8px', top: '3px' }}>*</span>
                                    <input className="w-full" type="text" placeholder="Họ tên"
                                        onChange={e => onChangeFieldValue('fullName', e.target.value)} value={dataDetail['fullName'] || ""} />
                                </div>
                                <div className="payment-info__line w-full flex items-center relative">
                                    <span style={{ color: 'red', position: 'absolute', left: '8px', top: '3px' }}>*</span>
                                    <input className="w-full" type="text" placeholder="Số điện thoại"
                                        onChange={e => onChangeFieldValue('phoneNumber', e.target.value)} value={dataDetail['phoneNumber'] || ""} />
                                </div>
                                <div
                                    className="payment-info__line payment-bank w-full flex items-center justify-between flex-wrap">
                                    <div className="location">
                                        <span style={{ color: 'red', position: 'absolute', left: '8px', top: '3px' }}>*</span>
                                        <select className="city-select w-full"
                                            onChange={e => onChangeCity(e.target.value)} defaultValue={""} value={dataDetail['cityCode']}>
                                            <option value="" disabled>Tỉnh/Thành...</option>
                                            {cities.length > 0 && (
                                                cities.map((item) => (
                                                    <option key={item.code} value={item.code}>{item.name}</option>
                                                ))
                                            )}
                                        </select>
                                    </div>
                                    <div className="location">
                                        <span style={{ color: 'red', position: 'absolute', left: '8px', top: '3px' }}>*</span>
                                        <select className="district-select w-full"
                                            onChange={e => onChangeDistrict(e.target.value)} defaultValue={""} value={dataDetail['districtCode']}>
                                            <option value="" disabled>Quận/Huyện...</option>
                                            {districts.length > 0 && (
                                                districts.map((item) => (
                                                    <option key={item.code} value={item.code}>{item.name}</option>
                                                ))
                                            )}
                                        </select>
                                    </div>
                                    <div className="location">
                                        <span style={{ color: 'red', position: 'absolute', left: '8px', top: '3px' }}>*</span>
                                        <select className="ward-select w-full"
                                            onChange={e => onChangeWard(e.target.value)} defaultValue={""} value={dataDetail['wardCode']}>
                                            <option value="" disabled>Phường/Xã...</option>
                                            {wards.length > 0 && (
                                                wards.map((item) => (
                                                    <option key={item.code} value={item.code}>{item.name}</option>
                                                ))
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <div className="payment-info__line w-full flex items-center relative">
                                    <span style={{ color: 'red', position: 'absolute', left: '8px', top: '3px' }}>*</span>
                                    <input className="w-full" type="text" placeholder="Địa chỉ"
                                        onChange={e => onChangeFieldValue('address', e.target.value)} value={dataDetail['address'] || ""} />
                                </div>
                                <div className="payment-info__line w-full flex items-center relative">
                                    <input className="w-full" type="text" placeholder="Email"
                                        onChange={e => onChangeFieldValue('email', e.target.value)} value={dataDetail['email'] || ""} />
                                </div>
                                <div className="payment-info__line w-full flex items-center relative">
                                    <input className="w-full" type="text" placeholder="Ghi chú"
                                        onChange={e => onChangeFieldValue('remark', e.target.value)} value={dataDetail['remark'] || ""} />
                                </div>
                            </Grid>
                            <Grid className="payment-method" item xs={5}>
                                <div className="title">
                                    <strong>PHƯƠNG THỨC THANH TOÁN</strong>
                                </div>
                                <div className="payment-info__line w-full items-center flex">
                                    <input name="payment-method" id="pmt-01" type="radio" value="cash" checked={dataDetail['paymentMethod'] === 'cash'}
                                        style={{ height: 'calc(48px + (57 - 48) * ((100vw - 375px)/ (1920 - 375)))' }}
                                        onChange={e => onChangeFieldValue('paymentMethod', 'cash')} />
                                    <label className="ml-2 mb-0 cursor-pointer" htmlFor="pmt-01">Thanh toán khi nhận hàng</label>
                                </div>
                                <div className="payment-info__line w-full items-center flex">
                                    <input name="payment-method" id="pmt-02" type="radio" value="bank" checked={dataDetail['paymentMethod'] === 'bank'}
                                        style={{ height: 'calc(48px + (57 - 48) * ((100vw - 375px)/ (1920 - 375)))' }}
                                        onChange={e => onChangeFieldValue('paymentMethod', 'bank')} />
                                    <label className="ml-2 mb-0 cursor-pointer" htmlFor="pmt-02">Chuyển khoản</label>
                                </div>
                                <div className="payment-checkout text-center block">
                                    <button className="inline-block btn-black" data-toggle="modal" data-target="#exampleModal" style={{ border: '1px solid #333' }}
                                        onClick={handleProcessOrder}
                                    >
                                        Đặt hàng
                                    </button>
                                </div>
                            </Grid>
                        </Grid>
                    </>)}
                </div>
            </div>
            <PaymentDialog
                open={open}
                banks={banks}
                order={orderResponse}
                onClose={handleClose}
            />
        </div>
    )
}

interface DialogProps {
    open: boolean;
    banks: any[];
    order: any;
    onClose: () => void;
}

const PaymentDialog = (props: DialogProps) => {
    const { onClose, open, banks, order } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>
                Thông tin chuyển khoản
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <MuiIcon name={ICON_NAME.FEATHER.X} />
            </IconButton>
            <DialogContent>
                {order && (
                    <div className="payment-expand">
                        <div><strong>Mã đơn hàng: {order.orderCode}</strong></div>
                        <div className="mb-4">
                            Cảm ơn quý khách đã mua hàng.
                            Quý khách vui lòng chuyển khoản để thanh toán đơn hàng với thông tin:
                        </div>
                        <hr className="mb-4" />
                        <ul className="bank-list">
                            {banks.map((_: any) => (
                                <li key={_.bankId} className="bank">
                                    <div className="flex">
                                        {/* <div className="bank-image">
                                        <img className="max-w-full max-h-full" src="assets/images/logo/bidv.png" alt="" />
                                    </div> */}
                                        <div className="bank-info flex items-center">
                                            <div className="">
                                                <div className="bank-name mb-2">{_.bankName}</div>
                                                <div className="bank-accnumber flex mb-2">
                                                    <span className="mr-2">STK: <strong className="stk">{_.bankAccountNumber}</strong></span>
                                                    <button className="--tooltip copy-stk" style={{ height: '22px', background: 'none', cursor: 'pointer' }}>
                                                        <span className="--tooltip-text">Sao chép</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22"
                                                            height="22" viewBox="0 0 24 24" fill="none"
                                                            stroke="#333" strokeWidth="1"
                                                            strokeLinecap="round" strokeLinejoin="round"
                                                            className="feather feather-copy">
                                                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className="bank-username">Tên: <strong>{_.bankAccountName}</strong></div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <hr className="mb-4" />
                        <div>Nội dung chuyển khoản: <strong>Thanh toan cho ma don hang: {order.orderCode}</strong></div>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default PaymentPage;